import { useQuery } from '@tanstack/react-query';
import costService from '../services/costService';

export const useCosts = (params = {}) => {
  return useQuery({
    queryKey: ['costs', params],
    queryFn: () => costService.getAllCosts(params),
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};

export const useCostStats = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['cost-stats', params],
    queryFn: () => costService.getCostStats(params),
    staleTime: 10 * 60 * 1000, // 10 minutos
    ...options
  });
};

export const useProfitMargins = () => {
  return useQuery({
    queryKey: ['profit-margins'],
    queryFn: () => costService.getProfitMargins(),
    staleTime: 15 * 60 * 1000, // 15 minutos
  });
};
